import { c as _c } from "react/compiler-runtime";
import type { PublicTrace } from '@onefootprint/request-types/dashboard';
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import CardTitle, { CardStatus } from '../card-title';
import Subsection from '../subsection';
import RuleTraceRow from './components/rule-trace-row';
import getRulePathSteps, { type RulePathStep } from './utils/get-rule-path-steps';
import getTraceRuleCounts from './utils/get-trace-rule-counts';
type ObeRulesProps = {
  trace: PublicTrace;
  /** Rules haven't run yet, so an empty trace means "not yet" rather than "none ran". */
  isAwaitingRules?: boolean;
};
const ObeRules = t0 => {
  const $ = _c(44);
  const {
    trace,
    isAwaitingRules
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.onboardingTrace"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let T0;
  let T1;
  let T2;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== isAwaitingRules || $[2] !== t || $[3] !== trace) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const steps = getRulePathSteps(trace);
      if (!steps.length) {
        let t6;
        if ($[11] !== isAwaitingRules || $[12] !== t) {
          t6 = isAwaitingRules ? t(_temp) : t(_temp2);
          $[11] = isAwaitingRules;
          $[12] = t;
          $[13] = t6;
        } else {
          t6 = $[13];
        }
        let t7;
        if ($[14] !== t6) {
          t7 = <Subsection><Card.Root><Card.Empty>{t6}</Card.Empty></Card.Root></Subsection>;
          $[14] = t6;
          $[15] = t7;
        } else {
          t7 = $[15];
        }
        t5 = t7;
        break bb0;
      }
      let T3;
      let getNoTriggerLabel;
      let getOutcome;
      let t6;
      let t7;
      if ($[16] !== t || $[17] !== trace) {
        const {
          triggered,
          skipped
        } = getTraceRuleCounts(trace);
        let t8;
        if ($[25] !== t) {
          t8 = t9 => {
            const {
              name,
              isNotEvaluated
            } = t9;
            if (isNotEvaluated) {
              return t(_temp3);
            }
            return name ? t(_temp4, {
              name
            }) : t(_temp5);
          };
          $[25] = t;
          $[26] = t8;
        } else {
          t8 = $[26];
        }
        getNoTriggerLabel = t8;
        getOutcome = _temp6;
        T2 = Subsection;
        T1 = Card.Root;
        T3 = CardTitle;
        if ($[27] !== t) {
          t6 = t(_temp7);
          $[27] = t;
          $[28] = t6;
        } else {
          t6 = $[28];
        }
        t7 = triggered ? <CardStatus tone="warning">{t(_temp8, {
            count: triggered
          })}</CardStatus> : <CardStatus tone={skipped ? "neutral" : "success"}>{t(_temp9)}</CardStatus>;
        $[16] = t;
        $[17] = trace;
        $[18] = T1;
        $[19] = T2;
        $[20] = T3;
        $[21] = getNoTriggerLabel;
        $[22] = getOutcome;
        $[23] = t6;
        $[24] = t7;
      } else {
        T1 = $[18];
        T2 = $[19];
        T3 = $[20];
        getNoTriggerLabel = $[21];
        getOutcome = $[22];
        t6 = $[23];
        t7 = $[24];
      }
      if ($[29] !== T3 || $[30] !== t6 || $[31] !== t7) {
        t4 = <T3 title={t6} rightContent={t7} />;
        $[29] = T3;
        $[30] = t6;
        $[31] = t7;
        $[32] = t4;
      } else {
        t4 = $[32];
      }
      T0 = Card.Body;
      t2 = "px-4 pt-4 pb-3";
      t3 = steps.map((step, index) => <RuleTraceRow key={step.id} triggered={step.conditions.length > 0} name={step.name} conditions={step.conditions} noTriggerLabel={getNoTriggerLabel(step)} isFirstEntry={index === 0} isLastEntry={index === steps.length - 1} outcome={getOutcome(step)} />);
    }
    $[1] = isAwaitingRules;
    $[2] = t;
    $[3] = trace;
    $[4] = T0;
    $[5] = T1;
    $[6] = T2;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[4];
    T1 = $[5];
    T2 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[33] !== T0 || $[34] !== t2 || $[35] !== t3) {
    t6 = <T0 className={t2}>{t3}</T0>;
    $[33] = T0;
    $[34] = t2;
    $[35] = t3;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  let t7;
  if ($[37] !== T1 || $[38] !== t4 || $[39] !== t6) {
    t7 = <T1>{t4}{t6}</T1>;
    $[37] = T1;
    $[38] = t4;
    $[39] = t6;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  let t8;
  if ($[41] !== T2 || $[42] !== t7) {
    t8 = <T2>{t7}</T2>;
    $[41] = T2;
    $[42] = t7;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  return t8;
};
export default ObeRules;
function _temp($) {
  return $.rulesPending;
}
function _temp2($_0) {
  return $_0.noRulesRan;
}
function _temp3($_1) {
  return $_1.notEvaluated;
}
function _temp4($_2) {
  return $_2.noRulesTriggeredName;
}
function _temp5($_3) {
  return $_3.noRulesTriggered;
}
function _temp6(t0) {
  const {
    kind,
    outcome,
    field
  } = t0;
  if (kind === "conditional") {
    return <span className="text-primary">{outcome}</span>;
  }
  return field && <span className="text-primary">data.{field} = {outcome}</span>;
}
function _temp7($_4) {
  return $_4.playbookRules;
}
function _temp8($_5) {
  return $_5.triggered;
}
function _temp9($_6) {
  return $_6.noRulesTriggered;
}